const asyncComponentFactory = (handle) => {
  return (node, ctx) => {
    return import(
      /* webpackChunkName: "[request]" */
      /* webpackMode: "lazy" */
      `./templates/${handle}`
    ).then((module) => {
      const instance = module.default(node, ctx);
      const unsubscribe = ctx.on('unmount', () => {
        instance.unmount();
        unsubscribe();
      });
    });
  };
};

export const AppTemplates = {
  //addresses: asyncComponentFactory('Account/Addresses'),
  //login: asyncComponentFactory('Account/Login'),
  //collection: asyncComponentFactory('Collection'),
  // product: asyncComponentFactory('Product'),
  // search: asyncComponentFactory('Collection'),
  //cart: asyncComponentFactory('Cart'),
};
